if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');

        // Preferimos el drawer moderno; si no, cart-notification como fallback
        this.cartDrawer = document.querySelector('cart-drawer');
        this.cartNotification = document.querySelector('cart-notification');
        this.cart = this.cartDrawer || this.cartNotification;

        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton
          ? this.submitButton.querySelector('span')
          : null;

        if (this.variantIdInput) {
          this.variantIdInput.disabled = false;
        }

        if (this.form) {
          this.form.addEventListener(
            'submit',
            this.onSubmitHandler.bind(this)
          );
        }

        if (this.cartDrawer) {
          // Solo ponemos aria-haspopup si existe el drawer
          this.submitButton &&
            this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';

        // ----------------------------
        // INICIO: Toggle + campo de texto + actualización de precio
        // ----------------------------

        // IDs de productos donde queremos mostrar el toggle
        const targetProductIds = [
          '10481049862471',
          '10480981213511',
          '10481071128903',
        ];

        if (!this.form) {
          console.warn(
            'product-form: no se encontró <form> dentro del componente'
          );
        } else {
          // Tomamos el ID del producto desde el input hidden
          const productIdInput = this.form.querySelector(
            'input[name="product-id"]'
          );
          const productId = productIdInput ? productIdInput.value : null;

          if (productId && targetProductIds.includes(productId)) {
            // Crear contenedor del toggle
            const toggleWrapper = document.createElement('div');
            toggleWrapper.style.marginTop = '15px';
            toggleWrapper.style.display = 'flex';
            toggleWrapper.style.alignItems = 'center';
            toggleWrapper.style.gap = '10px';

            toggleWrapper.innerHTML = `
              <label class="switch">
                <input type="checkbox" id="personalizacion" name="properties[Personalización]" value="Sí">
                <span class="slider"></span>
              </label>
              <span>Añadir personalización (+10€)</span>
            `;
            this.form.appendChild(toggleWrapper);

            // Campo de texto oculto
            const textWrapper = document.createElement('div');
            textWrapper.style.marginTop = '10px';
            textWrapper.style.display = 'none';
            textWrapper.innerHTML = `
              <input type="text" id="textoSerigrafia" name="properties[Texto Serigrafía]" 
                     placeholder="Escribe el texto que quieres serigrafiar" 
                     style="width:100%; padding:8px; border:1px solid #ccc; border-radius:4px;">
            `;
            this.form.appendChild(textWrapper);

            // Agregar CSS para toggle con color rosa
            const style = document.createElement('style');
            style.innerHTML = `
              .switch {
                position: relative;
                display: inline-block;
                width: 50px;
                height: 24px;
              }
              .switch input {
                opacity: 0;
                width: 0;
                height: 0;
              }
              .slider {
                position: absolute;
                cursor: pointer;
                top: 0; left: 0; right: 0; bottom: 0;
                background-color: #ccc;
                transition: .4s;
                border-radius: 24px;
              }
              .slider:before {
                position: absolute;
                content: "";
                height: 18px;
                width: 18px;
                left: 3px;
                bottom: 3px;
                background-color: white;
                transition: .4s;
                border-radius: 50%;
              }
              .switch input:checked + .slider {
                background-color: #E91E63; /* Rosa capote */
              }
              .switch input:checked + .slider:before {
                transform: translateX(26px);
              }
            `;
            document.head.appendChild(style);

            const checkbox = document.getElementById('personalizacion');

            // Helpers para trabajar con precios
            const getPriceElements = () =>
              Array.from(
                document.querySelectorAll(
                  '.price-item--regular, .price-item--sale'
                )
              );

            const parsePrice = text =>
              parseFloat(text.replace(/[^\d,.-]/g, '').replace(',', '.')) || 0;

            // guarda en data-base-price el precio base de la variante actual
            const refreshBasePrices = () => {
              const els = getPriceElements();
              els.forEach(el => {
                const base = parsePrice(el.innerText);
                el.dataset.basePrice = String(base);
              });
            };

            // aplica o quita los +10€ según el estado del checkbox
            const applyPersonalizationPrice = () => {
              const els = getPriceElements();
              els.forEach(el => {
                const base =
                  el.dataset.basePrice !== undefined
                    ? parseFloat(el.dataset.basePrice)
                    : parsePrice(el.innerText);

                let newPrice = base;
                if (checkbox.checked) newPrice += 10;

                el.innerText =
                  newPrice.toFixed(2).replace('.', ',') + '€';
              });
            };

            // inicializamos precios base al cargar
            refreshBasePrices();

            // Evento toggle
            checkbox.addEventListener('change', () => {
              textWrapper.style.display = checkbox.checked
                ? 'block'
                : 'none';
              applyPersonalizationPrice();
            });

            // Cuando cambie la variante, Shopify cambia el precio:
            // volvemos a guardar base y reaplicamos el recargo si el toggle está activo.
            if (this.variantIdInput) {
              this.variantIdInput.addEventListener('change', () => {
                // pequeño delay para dejar que el tema actualice el DOM del precio
                setTimeout(() => {
                  refreshBasePrices();
                  if (checkbox.checked) {
                    applyPersonalizationPrice();
                  }
                }, 50);
              });
            }
          }
        }

        // ----------------------------
        // FIN: Toggle + campo de texto + actualización de precio
        // ----------------------------
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (!this.form) return;
        if (!this.submitButton) return;

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', 'true');
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner')?.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        const personalizationCheckbox = this.form.querySelector('#personalizacion');
        const textInput = this.form.querySelector('#textoSerigrafia');

        if (personalizationCheckbox && personalizationCheckbox.checked) {
          const quantity = Number(formData.get('quantity') || 1);

          config.headers['Content-Type'] = 'application/json';

          config.body = JSON.stringify({
            items: [
              {
                id: '53871781970247',
                quantity,
                properties: {
                  'Texto Serigrafía': textInput ? textInput.value : '',
                },
              },
              {
                id: formData.get('id'),
                quantity,
                properties: {
                  'Personalización': 'Sí',
                },
              },
            ],
            sections: this.cartDrawer && typeof this.cartDrawer.getSectionsToRender === 'function'
              ? this.cartDrawer.getSectionsToRender().map(section => section.id)
              : undefined,
            sections_url: window.location.pathname,
          });
        } else {
          config.body = formData;
        }

        // Solo usamos secciones si tenemos cartDrawer y ese método existe
        if (
          this.cartDrawer &&
          typeof this.cartDrawer.getSectionsToRender === 'function'
        ) {
          formData.append(
            'sections',
            this.cartDrawer.getSectionsToRender().map(section => section.id)
          );
          formData.append('sections_url', window.location.pathname);

          if (typeof this.cartDrawer.setActiveElement === 'function') {
            this.cartDrawer.setActiveElement(document.activeElement);
          }
        }

        fetch(`${routes.cart_add_url}`, config)
          .then(response => response.json())
          .then(response => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', 'true');
              this.submitButtonText &&
                this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            // Si no tenemos drawer, redirigimos al carrito como fallback
            if (!this.cartDrawer) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            }

            this.error = false;

            const quickAddModal = this.closest('quick-add-modal');

            const canRenderCart =
              this.cartDrawer &&
              typeof this.cartDrawer.renderContents === 'function';

            if (quickAddModal && canRenderCart) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cartDrawer.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else if (canRenderCart) {
              this.cartDrawer.renderContents(response);
            } else {
              window.location = window.routes.cart_url;
            }
          })
          .catch(e => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (
              this.cartDrawer &&
              this.cartDrawer.classList.contains('is-empty')
            ) {
              this.cartDrawer.classList.remove('is-empty');
            }
            if (!this.error) {
              this.submitButton.removeAttribute('aria-disabled');
            }
            this.querySelector('.loading__spinner')?.classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute(
          'hidden',
          !errorMessage
        );

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton || !this.submitButtonText) return;

        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent =
            window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        if (!this.form) return null;
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
